if ( ! customElements.get('variant-selects') ) {

	/**
	 *  @class
	 *  @function VariantSelects
	 */
	class VariantSelects extends HTMLElement {
	  constructor() {
	    super();
			this.sticky = this.dataset.sticky;
			this.featured = this.dataset.featured;
	    this.addEventListener('change', this.onVariantChange);
	  }

	  onVariantChange() {
	    this.syncHardwareSwatchVisibility();
	    this.updateOptions();
	    this.updateMasterId();
	    this.toggleAddButton(true, '', false);
	    this.updatePickupAvailability();
	    this.removeErrorMessage();
	    this.updateVariantText();

	    if (!this.currentVariant) {
	      this.toggleAddButton(true, '', true);
	      this.setUnavailable();
	    } else {
	      this.updateMedia();
				if ( !this.featured ) {
		      this.updateURL();
				}
	      this.updateVariantInput();
	      this.renderProductInfo();
	      //this.updateShareUrl();
	    }
	  }

	  syncHardwareSwatchVisibility() {
	    const swatchGroup = this.querySelector('[data-swatch-group="hardware"]');
	    if (!swatchGroup) return;

	    const sizeInput = Array.from(this.querySelectorAll('fieldset input[type="radio"]:checked'))
	      .find((input) => input.name.toLowerCase().includes('size'));
	    if (!sizeInput) return;

	    const isUltraSize = sizeInput.value.toLowerCase().includes('ultra');
	    const wraps = Array.from(swatchGroup.querySelectorAll('.pdp-main__swatch-wrap'));
	    let checkedWrap = null;
	    let firstVisibleWrap = null;

	    wraps.forEach((wrap) => {
	      const isUltraSwatch = wrap.dataset.isUltra === 'true';
	      const shouldHide = isUltraSwatch !== isUltraSize;
	      wrap.classList.toggle('is-hidden', shouldHide);

	      const input = wrap.querySelector('input[type="radio"]');
	      if (input) {
	        input.disabled = shouldHide;
	        if (input.checked) checkedWrap = wrap;
	        if (!shouldHide && !firstVisibleWrap) firstVisibleWrap = wrap;
	      }
	    });

	    if ((!checkedWrap || checkedWrap.classList.contains('is-hidden')) && firstVisibleWrap) {
	      const fallbackInput = firstVisibleWrap.querySelector('input[type="radio"]');
	      if (fallbackInput) fallbackInput.checked = true;
	    }
	  }

	  updateOptions() {
	    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
	    this.options = [];
	    fieldsets.forEach((fieldset, i) => {
	      if (fieldset.querySelector('select')) {
	        this.options.push(fieldset.querySelector('select').value);
	      } else if (fieldset.querySelectorAll('input').length) {
	        this.options.push(fieldset.querySelector('input:checked').value);
	      }
	    });
	  }
	  updateVariantText() {
	    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
	    fieldsets.forEach((item, i) => {
	      let label = item.querySelector('.form__label__value');
	      if (label) {

	        label.innerHTML = this.options[i];
	      }
	    });
	  }
	  updateMasterId() {
	    this.currentVariant = this.getVariantData().find((variant) => {
	      return !variant.options.map((option, index) => {
	        return this.options[index] === option;
	      }).includes(false);
	    });
	  }
	  updateMedia() {
	    if (!this.currentVariant) return;
	    if (!this.currentVariant.featured_media) return;

			const productSlider = document.getElementById(`MediaGallery-${this.dataset.section}`);
			if (!productSlider) return;
			let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
			let activeMedia = productSlider.querySelector(`[data-media-id="${ mediaId }"]`);

			productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
			const slider = productSlider.querySelector('product-slider');
			if (slider && typeof slider.updateActiveThumbnail === 'function') {
				slider.updateActiveThumbnail(mediaId);
			}

			if ( this.featured) return;

			activeMedia.parentElement.prepend(activeMedia);

			window.setTimeout(() => {
      	activeMedia.parentElement.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      });
	  }

	  updateURL() {
	    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
	    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	  }

	  updateShareUrl() {
	    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
	    if (!shareButton) return;
	    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	  }

	  updateVariantInput() {
	    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
	    productForms.forEach((productForm) => {
	      const input = productForm.querySelector('input[name="id"]');
	      input.value = this.currentVariant.id;
	      input.dispatchEvent(new Event('change', {
	        bubbles: true
	      }));
	    });
	  }

	  updatePickupAvailability() {
	    const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

	    if (!pickUpAvailability) return;

	    if (this.currentVariant && this.currentVariant.available) {
	      pickUpAvailability.fetchAvailability(this.currentVariant.id);
	    } else {
	      pickUpAvailability.removeAttribute('available');
	      pickUpAvailability.innerHTML = '';
	    }
	  }

	  removeErrorMessage() {
	    const section = this.closest('section');
	    if (!section) return;

	    const productForm = section.querySelector('product-form');
	    if (productForm) productForm.handleErrorMessage();
	  }

		getSectionsToRender() {
	    return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`];
	  }

	  renderProductInfo() {
			let sections = this.getSectionsToRender();

			if ( this.classList.contains('variant-selects--sticky')) {
				sections.push(`variant-selects-${this.dataset.section}`);
			} else {
				sections.push(`variant-selects-${this.dataset.section}--sticky`);
			}
	    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
	      .then((response) => response.text())
	      .then((responseText) => {
					sections.forEach((id) => {
		        const html = new DOMParser().parseFromString(responseText, 'text/html');
		        const destination = document.getElementById(id);
		        const source = html.getElementById(id);

		        if (source && destination) destination.innerHTML = source.innerHTML;

		        const price = document.getElementById(id);
						const price_fixed = document.getElementById(id + '--sticky');

		        if (price) price.classList.remove('visibility-hidden');
						if (price_fixed) price_fixed.classList.remove('visibility-hidden');
		        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
					});

	      });
	  }

	  toggleAddButton(disable = true, text = false, modifyClass = true) {
	    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
	    if (!productForm) return;

			const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

			if (!submitButtons) return;

			submitButtons.forEach((submitButton) => {
				const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

		    if (!submitButtonText) return;

		    if (disable) {
		      submitButton.setAttribute('disabled', 'disabled');
		      if (text) submitButtonText.textContent = text;
		    } else {
		      submitButton.removeAttribute('disabled');
		      submitButton.classList.remove('loading');
		      submitButtonText.textContent = window.theme.variantStrings.addToCart;
		    }
			});

	    if (!modifyClass) return;
	  }

	  setUnavailable() {
			const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
			const price = document.getElementById(`price-${this.dataset.section}`);
			const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

			submitButtons.forEach((submitButton) => {
		    const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
		    if (!submitButton) return;
		    submitButtonText.textContent = window.theme.variantStrings.unavailable;
		    submitButton.classList.add('sold-out');
			});
			if (price) price.classList.add('visibility-hidden');
			if (price_fixed) price_fixed.classList.add('visibility-hidden');
	  }

	  getVariantData() {
	    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
	    return this.variantData;
	  }
	}
	customElements.define('variant-selects', VariantSelects);

	/**
	 *  @class
	 *  @function VariantRadios
	 */
	class VariantRadios extends VariantSelects {
	  constructor() {
	    super();
	  }

	  updateOptions() {
	    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
	    this.options = fieldsets.map((fieldset) => {
	      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
	    });
	  }
	}

	customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
	/**
	 *  @class
	 *  @function ProductSlider
	 */
	class ProductSlider extends HTMLElement {
	  constructor() {
			super();

			this.addEventListener('change', this.setupProductGallery);
		}
		connectedCallback() {
			const _this = this;
			const product_container = this.closest('.thb-product-detail');

			// Start Gallery
			this.setupProductGallery();
			this.setupThumbnailCarousel();
			this.setupCarouselSync();
		}
		setupThumbnailCarousel() {
			const container = this.closest('.product-image-container');
			if (!container) return;

			this.thumbnailCarousel = container.querySelector('.product-thumbnail-carousel');
			this.thumbnailButtons = container.querySelectorAll('.product-thumbnail-carousel__item');
			if (!this.thumbnailButtons.length) return;

			this.thumbnailButtons.forEach((button) => {
				button.addEventListener('click', () => {
					this.selectMedia(button.dataset.mediaId);
				});
			});
		}
		selectMedia(mediaId, options = {}) {
			const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
			if (!activeMedia) return;

			this.setActiveMedia(mediaId);

			if (options.scroll !== false) {
				this.scrollTo({
					left: activeMedia.offsetLeft - ((this.clientWidth - activeMedia.clientWidth) / 2),
					behavior: 'smooth',
				});
			}
		}
		setActiveMedia(mediaId, options = {}) {
			this.querySelectorAll('[data-media-id]').forEach((element) => {
				element.classList.toggle('is-active', element.dataset.mediaId === mediaId);
			});

			this.updateActiveThumbnail(mediaId, options);
		}
		updateActiveThumbnail(mediaId, options = {}) {
			const container = this.closest('.product-image-container');
			if (!container) return;

			container.querySelectorAll('.product-thumbnail-carousel__item').forEach((button) => {
				const isActive = button.dataset.mediaId === mediaId;
				button.classList.toggle('is-active', isActive);
				button.toggleAttribute('aria-current', isActive);

				if (isActive && options.scroll !== false) {
					this.scrollThumbnailIntoView(button);
				}
			});
		}
		scrollThumbnailIntoView(button) {
			if (!this.thumbnailCarousel) return;

			this.thumbnailCarousel.scrollTo({
				left: button.offsetLeft - ((this.thumbnailCarousel.clientWidth - button.clientWidth) / 2),
				behavior: 'smooth'
			});
		}
		setupCarouselSync() {
			if (!this.thumbnailButtons || !this.thumbnailButtons.length) return;

			this.addEventListener('scroll', () => {
				window.clearTimeout(this.carouselSyncTimeout);
				this.carouselSyncTimeout = window.setTimeout(() => this.syncActiveMediaFromScroll(), 80);
			}, { passive: true });
		}
		syncActiveMediaFromScroll() {
			const slides = Array.from(this.querySelectorAll('.product-images__slide[data-media-id]'));
			if (!slides.length) return;

			const carouselCenter = this.scrollLeft + (this.clientWidth / 2);
			const activeSlide = slides.reduce((closest, slide) => {
				const slideCenter = slide.offsetLeft + (slide.clientWidth / 2);
				const distance = Math.abs(carouselCenter - slideCenter);

				if (!closest || distance < closest.distance) {
					return { slide, distance };
				}
				return closest;
			}, null);

			if (activeSlide && activeSlide.slide) {
				this.setActiveMedia(activeSlide.slide.dataset.mediaId);
			}
		}
		setupProductGallery() {
			if ( ! this.querySelectorAll('.product-single__media-zoom').length ) {
				return;
			}
			let activeImages = Array.from(this.querySelectorAll('.product-single__media-image'));


			this.setEventListeners(this, activeImages);
		}
		buildItems(activeImages) {
			let images = activeImages.map((item) => {
				let activelink = item.querySelector('.product-single__media-zoom');
				return {
				  src: activelink.getAttribute('href'),
				  msrc: activelink.dataset.msrc,
				  w: activelink.dataset.w,
				  h: activelink.dataset.h
				};
			});
			return images;
		}
		setEventListeners(container, activeImages) {
			let links = container.querySelectorAll('.product-single__media-zoom'),
					items = container.buildItems(activeImages),
					pswpElement = document.querySelectorAll('.pswp')[0],
					options = {
						maxSpreadZoom: 2,
						loop: false,
						allowPanToNext: false,
						closeOnScroll: false,
						showHideOpacity: false,
						arrowKeys: true,
						history: false,
						captionEl: false,
						fullscreenEl: false,
						zoomEl: false,
						shareEl: false,
						counterEl: false,
						arrowEl: true,
						preloaderEl: true
					};


			links.forEach((link => {
				link.addEventListener('click', (event) => {
					let i = link.dataset.index;
					options.index = parseInt(i, 10);
					options.getThumbBoundsFn = () => {
						const thumbnail = link.closest('.product-single__media'),
									pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
									rect = thumbnail.getBoundingClientRect();
						return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
					};
					if (typeof PhotoSwipe !== 'undefined') {
						let pswp = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
						pswp.listen('firstUpdate', function() {
							pswp.listen('parseVerticalMargin', function(item) {
								item.vGap = { top: 50, bottom: 50};
							});
						});
						pswp.init();
					}
					event.preventDefault();
				});
			}));

		}
	}
	customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-description-toggle')) {
	class ProductDescriptionToggle extends HTMLElement {
		constructor() {
			super();
			this.button = this.querySelector('.product-description-toggle__button');
			this.content = this.querySelector('[data-product-description-content]');
			this.mobileQuery = window.matchMedia('(max-width: 768px)');
		}
		connectedCallback() {
			if (!this.button || !this.content) return;

			this.button.addEventListener('click', () => {
				const isExpanded = this.classList.toggle('is-expanded');
				this.button.setAttribute('aria-expanded', isExpanded.toString());
			});

			if (this.mobileQuery.addEventListener) {
				this.mobileQuery.addEventListener('change', () => this.refresh());
			}
			this.refresh();
			window.addEventListener('resize', () => this.refresh());
		}
		refresh() {
			if (!this.mobileQuery.matches) {
				this.classList.remove('is-expanded', 'has-overflow');
				this.button.setAttribute('aria-expanded', 'false');
				return;
			}

			const wasExpanded = this.classList.contains('is-expanded');
			this.classList.remove('is-expanded');
			this.classList.add('has-overflow');
			const hasOverflow = this.content.scrollHeight > this.content.clientHeight + 1;

			this.classList.toggle('has-overflow', hasOverflow);
			this.classList.toggle('is-expanded', wasExpanded && hasOverflow);
			this.button.setAttribute('aria-expanded', (wasExpanded && hasOverflow).toString());
		}
	}

	customElements.define('product-description-toggle', ProductDescriptionToggle);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

			this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
			if ( ! this.sticky ) {
	      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			}
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

			submitButtons.forEach((submitButton) => {
				if (submitButton.classList.contains('loading')) return;
				submitButton.setAttribute('aria-disabled', true);
	      submitButton.classList.add('loading');
			});

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
			let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);
          return this.capGiftWrapAfterAdd();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
					submitButtons.forEach((submitButton) => {
	          submitButton.classList.remove('loading');
	          submitButton.removeAttribute('aria-disabled');
					});
        });
    }

    getSectionsToRender() {
      return [{
	      id: 'Cart',
	      section: 'main-cart',
	      selector: '.thb-cart-form'
	    },
			{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    // Shared definitions live on theme.giftWrap (layout/theme.liquid).
    isGiftWrapLine(item) {
      return theme.giftWrap.isLine(item);
    }

    isQualifyingLine(item) {
      return theme.giftWrap.isQualifying(item);
    }

    capGiftWrapAfterAdd() {
      // The add response doesn't include the full cart, so reconcile against /cart.js:
      // if gift wraps now exceed the number of products, trim the excess and re-render.
      return fetch(`${theme.routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          if (!cart || !Array.isArray(cart.items)) {
            return null;
          }

          const giftWrapLines = cart.items.filter((item) => this.isGiftWrapLine(item));
          if (!giftWrapLines.length) {
            return null;
          }

          const productUnits = cart.items.reduce((total, item) => {
            return this.isQualifyingLine(item) ? total + item.quantity : total;
          }, 0);
          const giftWrapUnits = giftWrapLines.reduce((total, item) => total + item.quantity, 0);

          if (giftWrapUnits <= productUnits) {
            return null;
          }

          let excess = giftWrapUnits - productUnits;
          const sections = this.getSectionsToRender().map((section) => section.section);
          const changes = [];
          for (let i = giftWrapLines.length - 1; i >= 0 && excess > 0; i--) {
            const gwLine = giftWrapLines[i];
            const reduceBy = Math.min(excess, gwLine.quantity);
            changes.push({ key: gwLine.key, quantity: gwLine.quantity - reduceBy });
            excess -= reduceBy;
          }

          return changes.reduce((chain, change) => {
            return chain.then(() => fetch(`${theme.routes.cart_change_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: change.key,
                quantity: change.quantity,
                sections,
                sections_url: window.location.pathname
              })
            }).then((response) => response.json()));
          }, Promise.resolve(null));
        })
        .then((finalState) => {
          if (finalState) {
            this.renderContents(finalState);
          }
        });
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
				if ( ! document.getElementById(section.id) ) {
					return;
				}
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        let quantities = elementToReplace.querySelectorAll('.quantity:not(.buttons_added)');

        if (quantities) {
          quantities.forEach((quantity) => {
            new QuantityInput(quantity);
          });
        }
				if (typeof CartDrawer !== 'undefined') {
				  new CartDrawer();
				}
				if (typeof Cart !== 'undefined') {
			    new Cart().renderContents(parsedState);
			  }
      }));



			let product_drawer = document.getElementById('Product-Drawer');
			if ( product_drawer && product_drawer.contains(this) ) {
				product_drawer.querySelector('.product-quick-images--container').classList.remove('active');

				if ( window.innerWidth < 1069 ) {
					product_drawer.classList.remove('active');
					if ( document.getElementById('Cart-Drawer') ) {
						document.getElementById('Cart-Drawer').classList.add('active');
					}
				} else {
					product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
						product_drawer.classList.remove('active');

						if ( document.getElementById('Cart-Drawer') ) {
				      document.getElementById('Cart-Drawer').classList.add('active');
						}
					});
				}

				if ( ! document.getElementById('Cart-Drawer') ) {
					this.body.classList.remove('open-cc');
				}
			} else if ( document.getElementById('Cart-Drawer') ) {
				this.body.classList.add('open-cc');
	      document.getElementById('Cart-Drawer').classList.add('active');
			}
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
	class ProductAddToCartSticky extends HTMLElement {
		constructor() {
	    super();
			this.mobileQuery = window.matchMedia('(max-width: 768px)');
	  }
		connectedCallback() {
			this.nativeButton = document.getElementById('AddToCart');
			this.isNativeButtonVisible = true;
			this.setupObserver();
			this.updateNativeButtonVisibility();
			this.updateVisibility();

			if (this.mobileQuery.addEventListener) {
				this.mobileQuery.addEventListener('change', () => this.updateVisibility());
			}
		}
		setupObserver() {
			if (!this.nativeButton) return;

			if (!('IntersectionObserver' in window)) {
				window.addEventListener('scroll', () => {
					this.updateNativeButtonVisibility();
					this.updateVisibility();
				}, { passive: true });
				window.addEventListener('resize', () => {
					this.updateNativeButtonVisibility();
					this.updateVisibility();
				});
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.target === this.nativeButton) {
						this.isNativeButtonVisible = entry.isIntersecting;
					}
				});
				this.updateVisibility();
			}, {
				threshold: 0.1
			});

			observer.observe(this.nativeButton);
		}
		updateNativeButtonVisibility() {
			if (!this.nativeButton) return;

			const rect = this.nativeButton.getBoundingClientRect();
			this.isNativeButtonVisible = rect.bottom > 0 && rect.top < window.innerHeight;
		}
		updateVisibility() {
			const shouldShow = this.mobileQuery.matches && !this.isNativeButtonVisible;
			this.classList.toggle('sticky--visible', shouldShow);
			// Lift floating app widgets (chat, ADA) above the bar while it's shown.
			document.body.classList.toggle('sticky-atc-visible', shouldShow);
			if (shouldShow) {
				document.body.style.setProperty('--sticky-atc-height', this.offsetHeight + 'px');
			}
		}
	}

	customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
	class ProductSidePanelLinks extends HTMLElement {
		constructor() {
	    super();
			this.links = this.querySelectorAll('button');
			this.drawer = document.getElementById('Product-Information-Drawer');
			this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
			this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
			this.body = document.body;
	  }
		connectedCallback() {
			this.setupObservers();
		}
		disconnectedCallback() {

		}
		setupObservers() {
			this.links.forEach((item, i) => {
				item.addEventListener('click', (e) => {
					this.body.classList.add('open-cc');
					this.buttons.toggleActiveClass(i);
					this.drawer.classList.add('active');
				});
			});
		}
	}

	customElements.define('side-panel-links', ProductSidePanelLinks);
}